import PropTypes from 'prop-types';
import excel from '@/assets/images/excel.svg';
import { exportToExcel } from './excelExport';
import { Button } from 'antd';
import { showToast } from '../toastMessage/ToastMessage';

const ExcelButton = ({
  data,
  fileName,
  title,
  startDate,
  endDate,
  columns,
  titleColumn,
  hideDate,
  isTotalBold = false,
  isStockledgerReport = false,
  isLedgerReport = false,
  totalData = {},
  isLedgerDetailsReport,
  totalExcelFooter,
  ledgerName,
  boldRowIndexes,
}) => {
  const handleExport = () => {
    if (!data || data?.length === 0) {
      showToast('No data available to export to Excel.', 'warn');
      return;
    }
    exportToExcel({
      data,
      filename: fileName,
      title,
      startDate,
      endDate,
      columns,
      titleColumn,
      hideDate,
      isTotalBold,
      isStockledgerReport,
      isLedgerReport,
      totalData,
      isLedgerDetailsReport,
      totalExcelFooter,
      ledgerName,
      boldRowIndexes,
    });
  };

  return (
    <Button
      type="button"
      onClick={handleExport}
      style={{ border: 'none', background: 'none', padding: 0 }}
    >
      <img className="table-icon" src={excel} alt="Download PDF" />
    </Button>
  );
};

ExcelButton.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  fileName: PropTypes.string,
  title: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  boldRowIndexes: PropTypes.arrayOf(PropTypes.number),
};

export default ExcelButton;
